import styled from 'styled-components';

interface PreviewPageImageProps {
	zoom: number;
}

const StyledPreviewPage = styled('div')`
	position: relative;
	flex: 1 1 auto;
`;

const PreviewPageImage = styled('img')`
	box-sizing: border-box;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 50%;
	right: 0;
	width: auto;
	height: auto;
	max-width: ${({ zoom }: PreviewPageImageProps) => zoom * 100}%;
	max-height: ${({ zoom }: PreviewPageImageProps) => zoom * 100}%;
	padding: ${({ zoom }: PreviewPageImageProps) => 27 / zoom}px;
	padding-left: 0;
	transform: translateX(-50%) scale(${({ zoom }: PreviewPageImageProps) => zoom});
	transform-origin: ${({ zoom }: PreviewPageImageProps) => zoom < 1 ? 'center top' : '0 0'};
`;

export {
	StyledPreviewPage,
	PreviewPageImage,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/PreviewPage/styles.ts